import { API } from "../../../utils";

export const getTenantLoyaltySettingsApi = async () => {
  const res = await API.get("/settings/loyalty");
  return res.data;
};

export const updateTenantLoyaltySettingsApi = async (payload) => {
  const res = await API.put("/settings/loyalty", payload);
  return res.data;
};
